import styled from 'styled-components';

export const StyledHistoricalVisitElectronicDocumentItemWrapper = styled.div`
   display: flex;
   justify-content: space-between;

   & > p {
      margin: 0.2em 0;
   }
`;
StyledHistoricalVisitElectronicDocumentItemWrapper.displayName = 'StyledHistoricalVisitElectronicDocumentItemWrapper';
